import React from 'react';
import axios from 'axios';
import hyperid from 'hyperid';
import queryString from 'query-string';
import { isString, get, size } from 'lodash';
// import Autosuggest from 'react-autosuggest';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { camelCase } from 'change-case';
import md5 from 'md5';
import { processQuestionsAnswersNew, processQuestionsAnswers, checkLogicalAnswer } from '../../utils';
import { withTranslation } from 'react-i18next';
import PurposeOfVisitTerminalTemplate from '../../components/terminalTemplates/PurposeOfVisitTerminalTemplate.js';
import VisitorTerminalTemplate from '../../components/terminalTemplates/VisitorTerminalTemplate.js';

import { questionTypes } from '../../shared/GeneralQuestionnaire';
import Pagination from '../../shared/Pagination';

import '../../App.css';
import Store from '../../store';
import qrcodeImg from '../../static/icons/image_1.png';

const fromEntries = require('object.fromentries');

if (!Object.fromEntries) {
  fromEntries.shim();
}

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

class TerminalMainPage extends React.Component {
  constructor(props) {
    super(props);

    const parsedQueryString = queryString.parse(window.location.search);
    this.siteId = parseInt(parsedQueryString.siteId, 10);
    this.employeeId = parseInt(parsedQueryString.employeeId, 10);

    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.state = {
      hosts: [],
      showHostError: false,
      suggestedHosts: [],
      selectedHost: '',
      selectedHostDetails: undefined,
      skippedToLast: false,
      selectedVisitorType: {
        template: undefined,
        typeId: undefined,
      },
      filteredQuestions: [],
      initialValues: {
        name: '',
        employeeCode: '',
        mobilePhoneNumber: '',
        email: '',
        company: '',
        nameOfHost: '',
        entryType: '',
      },
      userName: '',
      isResultModal: false,
      selectedStage: 0,
      paginationMax: 999,
    };
    this.answersMap = new Map();
    this.instance = hyperid();
    this.formData = new FormData();

    this.formData.set('template', undefined);
    this.formData.set('typeId', undefined);
    this.formData.set('siteId', this.siteId);
    this.formData.set('accountId', -1);
    this.mustCompleteQuestionnaire = true;
    this.ref = React.createRef();
    this.ref.current = { lastPages: [] };
  }

  async componentDidMount() {
    this.session = await this.initSession();
    this.site = await this.initSiteDetails();
    this.host = await this.initHost();

    const enabledVisitorTypes = this.site.visitorTypes.filter((v) => { return v.state && v.template !== 7});
    this.setState({
      site: this.site,
      hosts: this.host.data.employees,
      suggestedHosts: this.host.data.employees,
      visitorTypes: enabledVisitorTypes,
      purposes: this.site.purposes,
    });
  }

  async initSession() {
    const id = this.instance.uuid;
    await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: this.siteId,
    });
    const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: this.siteId,
    });
    return login.data;
  }

  initHost() {
    return axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/host?siteId=${this.siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });
  }

  async initSiteDetails() {
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${this.siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });
    return data.site;
  }

  async validateEmployeeCode(code) {
    try {
      const res = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/employees/getByCode?employeeCode=${code}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: this.session.id,
        },
      });
      return res;
    } catch (error) {
      return false;
    }
  }

  handleEntryTypeChange = async (setFieldValue, flag, e) => {
    this.answersMap.clear();
    const { value } = e.target;
    const [visitorType] = this.state.visitorTypes.filter((v) => v.name === value);
    if (visitorType.name === 'employee') {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ routing: visitorType.name }));
      }
      return;
    }

    if (visitorType !== undefined) {
      let updatedQuestions = [];
      const initialValues = this.state.initialValues;
      if (this.state.site.isEnableIfThenQuestionnaire) {
        const logicalQuestionnaire = (this.state.site.logicalQuestionnaire || []).find((q) => q.visitorTypes.includes(visitorType.roleId));
        if (logicalQuestionnaire) {
          updatedQuestions = logicalQuestionnaire.logicalQuestions.map((lq) => {
            const q = lq.question;
            const label = isString(get(q, 'label')) ? q.label : get(q, `label[${this.language}]`) || '';
            const hashedLabel = md5(camelCase(label || ''), {
              algorithm: 'md5',
            });
            q.inputName = `question_inputN_${q.uuid || q.inputN}_${hashedLabel}`;
            return { ...lq, question: q };
          });
        } else {
          updatedQuestions = this.getGeneralQuestionnaire(visitorType);
          this.setState({ site: { ...this.state.site, isEnableIfThenQuestionnaire: false } });
        }
      } else {
        updatedQuestions = this.getGeneralQuestionnaire(visitorType);
      }
      updatedQuestions.forEach((q) => {
        if (q.type === questionTypes.TEXT) {
          initialValues[q.inputName] = '';
        }
        if (q.type === questionTypes.RADIOBUTTON) {
          initialValues[q.inputName] = this?.state?.site?.mandatoryAnswersToQuestions === false ? false : null;
        }

        if (q.type === questionTypes.NUMBER) {
          initialValues[q.inputName] = this?.state?.site?.mandatoryAnswersToQuestions === false ? 0 : null;
        }
      });
      this.setState({
        filteredQuestions: [...updatedQuestions],
        selectedVisitorType: visitorType,
        initialValues,
      });
      this.formData.set('typeId', visitorType.id);
      this.formData.set('roleId', visitorType.roleId);
    }

    await setFieldValue('entryType', value);
    if (flag) {
      const selectedPage = this.state.selectedStage + 1;

      this.setPage(selectedPage);
    }
  };

  getGeneralQuestionnaire = (visitorType) => {
    const questions = this.state.site.questions.map((q) => {
      const label = isString(get(q, 'label')) ? q.label : get(q, `label[${this.language}]`) || '';
      const hashedLabel = md5(camelCase(label || ''), {
        algorithm: 'md5',
      });
      q.inputName = `question_inputN_${q.uuid || q.inputN}_${hashedLabel}`;
      return q;
    });
    return questions.filter((q) => q.visitorTypes.includes(visitorType.roleId));
  };

  parseImageStringFromDataUrl = (dataUrl) => {
    const splittedData = dataUrl.split('data:image/png;base64,');
    return splittedData[1];
  };

  handleFormSubmit = async (values) => {
    // console.warn('handleFormSubmit', values);
    for (const property in values) {
      this.formData.set(property, values[property]);

      if (property.includes('question_inputN_')) {
        this.answersMap.set(property, values[property]);
        this.formData.delete(property);
      }
    }

    this.setState({
      ...this.state,
      userName: values.name,
    });
    let responsePageBuilderData = null;
    let isResultModal = false;
    let success = true;

    if (this.state.filteredQuestions.length > 0) {
      let formattedAnswers = this.state.site.isEnableIfThenQuestionnaire
        ? processQuestionsAnswersNew(this.answersMap, this.state.filteredQuestions)
        : processQuestionsAnswers(this.answersMap, this.state.filteredQuestions);
      formattedAnswers.some((item) => {
        if (this.state.site.isEnableIfThenQuestionnaire) {
          if (checkLogicalAnswer(item, item.question.answer)) {
            isResultModal = true;
            let key = item.question.answer === true ? 'yes' : 'no';
            if (item.default) key = 'no';
            responsePageBuilderData = item[key].data;
            return true;
          }
        } else {
          if (Number(item.answer) === item.notification && (item.type === 1 || item.type === 3)) {
            isResultModal = true;
            return true;
          }
        }
        return false;
      });
      formattedAnswers = formattedAnswers.map((fa) => {
        return this.state.site.isEnableIfThenQuestionnaire ? fa.question : fa;
      });

      //let check show code or not
      formattedAnswers.some((item) => {
        if (item.type === 3) {
          console.log(item.answer);
        }
        if (Number(item.answer) === item.notification && (item.type === 1 || item.type === 3)) {
          success = false;
          return true;
        }
        return false;
      });

      this.formData.set('answers', JSON.stringify(formattedAnswers));
    }

    this.formData.set('template', this.state.selectedVisitorType.template);
    this.formData.set('typeId', this.state.selectedVisitorType.id);
    this.formData.set('accountId', this.state.site.accountId);
    if (this.state.selectedVisitorType.name?.toLowerCase() !== 'employee' && this.state.selectedHostDetails) {
      this.formData.set('employeeId', this.state.selectedHostDetails.id);
    }
    //we can't rely result success
    const result = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/signin?siteId=${this.siteId}`, this.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });

    if (result && result.data && result.data.visitorId) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ id: result.data.visitorId.visitorId.toString() }));
      }
      sessionStorage.setItem(
        'submitedData',
        JSON.stringify({
          name: values.name,
          siteName: this.state.site.name,
          inviteCode: result.data.visitorId.inviteCode,
          success: success,
          isEnableQrCodeWithPinInside: this.state.site.isEnableQrCodeWithPinInside,
          isScanTemperature: this.state.selectedVisitorType.isScanTemperature,
          pageData: responsePageBuilderData,
        }),
      );
      this.setState({
        ...this.state,
        isResultModal: isResultModal,
      });
      // MAYBE WE CAN DELETE IT
      Store.inviteCode = result.data.visitorId.inviteCode;
    }
    if (!this.state.site.isEnableIfThenQuestionnaire) {
      if (!isResultModal && this.state.selectedVisitorType.isScanTemperature) {
        this.props.history.push('/temperature');
      } else if (!isResultModal && !this.state.selectedVisitorType.isScanTemperature) {
        this.props.history.push('/withouttemperature');
      } else if (isResultModal) {
        this.props.history.push('/rejected');
      }
    } else {
      //isEnableIfThenQuestionnaire is enabled
      if (this.state.selectedVisitorType.isScanTemperature) {
        if (success) {
          this.props.history.push('/temperature');
        } else {
          this.props.history.push('/responsewithouttemperature');
        }
      } else {
        this.props.history.push('/responsewithouttemperature');
      }
    }
  };

  buildValidationSchema = (questions, hasHost, hasPurposes, values) => {
    // console.log('hasPurposes', hasPurposes);
    let visitorSignInSchema = true
      ? // this.state.selectedVisitorType.name?.toLowerCase() !== 'employee'
        Yup.object().shape({
          name: Yup.string().required('Your name is required'),
          mobilePhoneNumber: this.phoneValueScheme(),
          // email: Yup.string()
          //   .email(),
          company: this.companyValueScheme(),
          nameOfHost: hasHost ? Yup.string().required('The host name you visit is required') : Yup.string(),
          purposeOfVisit: hasPurposes ? Yup.string().required('The purpose of your visit is required') : Yup.string(),
          entryType: Yup.string().required('The entry type is required'),
        })
      : Yup.object().shape({
          name: Yup.string().required('Your name is required'),
          employeeCode: Yup.number().required('Password is required'),
        });

    if (questions.length === 0) {
      return visitorSignInSchema;
    }

    let questionsSchema = [];
    if (!this.state.skippedToLast) {
      questionsSchema = questions.map((lq) => {
        const q = this.state.site.isEnableIfThenQuestionnaire ? lq.question : lq;
        if (q.type === questionTypes.RADIOBUTTON) {
          if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
            return [q.inputName, Yup.boolean().required('Please answer the question').nullable()];
          } else {
            return [q.inputName, Yup.boolean().nullable()];
          }
        }

        if (q.type === questionTypes.NUMBER) {
          if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
            return [q.inputName, Yup.number().required('Please answer the question').nullable()];
          } else {
            return [q.inputName, Yup.number().nullable()];
          }
        }

        if (q.type === questionTypes.NONRESPONSE) {
          if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
            return [Yup.number().notRequired()];
          }
          return [q.inputName, Yup.number().notRequired()];
        }

        if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
          return [q.inputName, Yup.string().required('Please answer the question').nullable()];
        } else {
          return [q.inputName, Yup.string().nullable()];
        }
      });
    }

    if (!Object.entries)
      Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array

        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
      };

    for (let i = 0; i < questions.length; i++) {
      visitorSignInSchema = true
        ? // this.state.selectedVisitorType.name?.toLowerCase() !== 'employee'
          Yup.object()
            .shape({
              name: Yup.string().required('Your name is required3'),
              mobilePhoneNumber: this.phoneValueScheme(),
              // email: Yup.string()
              //   .email()
              //   .required('Your email address is required'),
              company: this.companyValueScheme(),
              nameOfHost: hasHost ? Yup.string().required('The host name you visit is required') : Yup.string(),
              purposeOfVisit: hasPurposes ? Yup.string().required('The purpose of your visit is required') : Yup.string(),
              entryType: Yup.string().required('The entry type is required'),
            })
            .shape(Object.fromEntries(questionsSchema))
        : Yup.object()
            .shape({
              name: Yup.string().required('Your name is required'),
              employeeCode: Yup.number().required('Password is required'),
            })
            .shape(Object.fromEntries(questionsSchema));
    }

    return visitorSignInSchema;
  };

  companyValueScheme = () => {
    if (this?.state?.site?.mandatoryCompanyName && (this?.state?.site?.displayCompany || this?.state?.site?.displayCompany === undefined)) {
      return Yup.string().required('Your company name is required');
    }
    return Yup.string();
  };

  phoneValueScheme = () => {
    if (this?.state?.site?.mandatoryPhoneNumber) {
      return Yup.string().required('Your mobile phone is required').nullable();
    }
    return Yup.string().nullable();
  };

  onResultModalSubmit = () => {
    this.setState({
      ...this.state,
      isResultModal: false,
    });
  };

  setPage(number) {
    const pages = document.querySelectorAll('.questionPart');

    this.setState({ paginationMax: pages.length, selectedStage: number });
    pages.forEach((page, index) => {
      if (index === number) {
        page.classList.add('active');
      } else {
        page.classList.remove('active');
      }
    });
  }

  onNextClick = () => {
    // console.log('filteredQuestions onNext', this.state.filteredQuestions);

    if (this.state.selectedStage === 2) {
      const el = document.getElementById('nameOfHost');
      const nameOfHost = el && el.value;

      const found = this.state.hosts.find((element) => element.name === nameOfHost);
      if (!found && el) {
        this.setState({ showHostError: true });
        return;
      }
    }

    this.setState({ showHostError: false });

    const selectedPage = this.state.site.isEnableIfThenQuestionnaire ? this.getNextPageBasedOnAnswer(this.state.selectedStage) : this.state.selectedStage + 1;

    this.setPage(selectedPage);
  };

  getNextPageBasedOnAnswer = (currentIndex) => {
    let index = currentIndex;
    const hasPurpose = Number(this.state.selectedVisitorType?.template) === 6;
    let mandatoryQuestionsBeforeQuestionnaire = hasPurpose ? (Boolean(size(this.state.purposes)) ? 3 : 2) : 3;
    if (currentIndex >= mandatoryQuestionsBeforeQuestionnaire) {
      const { values } = this.formik;
      const questionIndex = currentIndex - mandatoryQuestionsBeforeQuestionnaire;
      const questionWrapper = this.state.filteredQuestions[questionIndex];
      const { question } = questionWrapper;
      if (questionWrapper.default) {
        if (questionWrapper['no'].type === 'QUESTION') {
          console.log('go to next question');
          index = this.getQuestionIndexBasedOnUuid(questionWrapper['no'].data) + mandatoryQuestionsBeforeQuestionnaire - 1;
        } else {
          console.log('go to response page');
          this.setState({ skippedToLast: true });
          index = this.state.paginationMax - 2;
        }
      } else {
        const inputKey = question.inputName;
        const response = values[inputKey] || false;
        const responseEnumKey = response ? 'yes' : 'no';

        if (questionWrapper[responseEnumKey].type === 'QUESTION') {
          console.log('go to next question');
          index = this.getQuestionIndexBasedOnUuid(questionWrapper[responseEnumKey].data) + mandatoryQuestionsBeforeQuestionnaire - 1;
        } else {
          console.log('go to response page');
          this.setState({ skippedToLast: true });
          index = this.state.paginationMax - 2;
        }
      }
    }
    this.setState({ lastPage: currentIndex }); //saving lastPage
    this.ref.current.lastPages.push(currentIndex);
    return index + 1;
  };

  getQuestionIndexBasedOnUuid = (uuid) => {
    return this.state.filteredQuestions.findIndex((lq) => lq.uuid === uuid);
  };

  onPrevClick = () => {
    let selectedPage;
    if (this.state.site.isEnableIfThenQuestionnaire) {
      selectedPage = this.ref.current.lastPages.pop();
      this.setState({ lastPage: null, skippedToLast: false });
    } else {
      selectedPage = this.state.selectedStage - 1;
    }
    this.setPage(selectedPage);
  };

  submitEmployee = async (code) => {
    const response = await this.validateEmployeeCode(code);
    if (response) {
      return this.onNextClick({});
    } else {
      return alert('Try again');
    }
  };

  render() {
    const { t } = this.props;
    const { site, filteredQuestions, selectedVisitorType, initialValues, purposes } = this.state;
    if (site === undefined)
      return (
        <div className="container w-full max-w-xs mx-auto">
          <p className="text-center mt-4">{t('Loading')}...</p>
        </div>
      );

    // const isVisitorFullTypeTemplate = Number(selectedVisitorType?.template) === 0;
    const isPurposeOfVisitTypeTemplate = Number(selectedVisitorType?.template) === 6;

    // console.log('selectedVisitorType.template', selectedVisitorType?.template, selectedVisitorType?.name);
    return (
      <div className={true ? 'w-full mx-auto' : 'container w-full max-w-xs mx-auto'}>
        <Formik
          initialValues={initialValues}
          validationSchema={() =>
            Yup.lazy((values) => {
              return this.buildValidationSchema(filteredQuestions, !isPurposeOfVisitTypeTemplate, isPurposeOfVisitTypeTemplate && purposes.length, values);
            })
          }
          onSubmit={this.handleFormSubmit}
          innerRef={(p) => (this.formik = p)}
        >
          {({ errors, touched, values, handleChange, handleBlur, setFieldValue, isSubmitting }) => {
            console.log({ errors });
            return (
              <Form className="TerminalMainPage bg-blue-gradient shadow-md px-8 pt-6 pb-8 mb-4 full-window text-white text-2xl">
                <div className={'questionPart active'}>
                  {/* // FIRST PAGE TYPE OF VISITOR */}
                  <h1 className="text-lg font-bold text-center mt-4">
                    {t('welcome to')}
                    <br />
                    {site.name ? site.name : ''}
                  </h1>
                  {/*<div className="p-2">*/}
                  {/*  <img*/}
                  {/*    className="mx-auto h-24 object-center object-none"*/}
                  {/*    src={`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getLogo/${this.siteId}?small=true&access_token=${this.session.id}`}*/}
                  {/*    alt={site.name ? site.name : ''}*/}
                  {/*  />*/}
                  {/*</div>*/}

                  <div className="text-lg mb-4 text-center">
                    <div style={{ fontSize: 35 }}>{t('What type of visitor are you?')}</div>
                    <br />
                    <div className="visitorTypes">
                      {this.state.visitorTypes.map((v, index) => (
                        <button
                          type="button"
                          name="entryType"
                          className={'w-full py-2 visitorBtn'}
                          style={{ fontSize: 35 }}
                          onClick={this.handleEntryTypeChange.bind(this, setFieldValue, true)}
                          id="entryType"
                          key={index}
                          data-visitor-type-role-id={v.roleId}
                          value={v.name}
                        >
                          {t(v.name)}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {isPurposeOfVisitTypeTemplate ? (
                  // SOURCE TERMINAL FOR PURPOSE OF VISIT
                  <PurposeOfVisitTerminalTemplate
                    purposes={purposes}
                    errors={errors}
                    values={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    selectedVisitorType={selectedVisitorType}
                    touched={touched}
                    filteredQuestions={filteredQuestions}
                    isSubmitting={isSubmitting}
                    onPrevClick={this.onPrevClick}
                    displayCompany={this.state.site.displayCompany}
                    questionsEnabled={this.state.site.questionsEnabled}
                    isEnableIfThenQuestionnaire={this.state.site.isEnableIfThenQuestionnaire}
                    {...this.props}
                  />
                ) : (
                  // SOURCE TERMINAL FOR VISITORS
                  <VisitorTerminalTemplate
                    purposes={purposes}
                    errors={errors}
                    values={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    selectedVisitorType={selectedVisitorType}
                    touched={touched}
                    filteredQuestions={filteredQuestions}
                    isSubmitting={isSubmitting}
                    onPrevClick={this.onPrevClick}
                    setFieldValue={setFieldValue}
                    showHostError={this.state.showHostError}
                    hosts={this.state.hosts}
                    onHostChanged={(details) => this.setState({ selectedHostDetails: details })}
                    displayCompany={this.state.site.displayCompany}
                    questionsEnabled={this.state.site.questionsEnabled}
                    isEnableIfThenQuestionnaire={this.state.site.isEnableIfThenQuestionnaire}
                    {...this.props}
                  />
                )}
                <Pagination
                  selectedStage={this.state.selectedStage}
                  onPrevClick={this.onPrevClick}
                  onNextClick={this.onNextClick}
                  paginationMax={this.state.paginationMax}
                  touched={touched}
                  errors={errors}
                />

                {this.state.selectedStage === 0 && this.state.selectedStage !== this.state.paginationMax && (
                  <div
                    className="qrcodeBtn"
                    onClick={() => {
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({ routing: 'qr' }));
                      }
                    }}
                  >
                    <img src={qrcodeImg} alt="qrcodeImg" />
                  </div>
                )}
              </Form>
            );
          }}
        </Formik>
        <p className="text-center text-gray-500 text-xs">&copy;2020 My Lobby. All rights reserved. TMP.</p>
      </div>
    );
  }
}

export default withRouter(withTranslation()(TerminalMainPage));
